import React, { useEffect, useState } from 'react';
import type { ArticleSection } from '../../data/articles';
interface ArticleTOCProps {
  sections: ArticleSection[];
  /** Anchor id of the FAQ block appended to the end of the list. */
  faqId: string;
}

/**
 * Sticky in-page navigation for long-form articles. Highlights the section
 * currently in view so readers keep their place in a 10-minute read.
 */
export function ArticleTOC({
  sections,
  faqId
}: ArticleTOCProps) {
  const [activeId, setActiveId] = useState<string>(sections[0]?.id ?? '');
  useEffect(() => {
    const ids = [...sections.map(section => section.id), faqId];
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActiveId(visible[0].target.id);
    }, {
      rootMargin: '-96px 0px -70% 0px',
      threshold: 0
    });
    ids.forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [sections, faqId]);
  return <nav aria-label="On this page" className="border-l border-gray-200 pl-5" data-id="element-149" data-mp="jrvw8mboy7et">
      <h2 className="text-[11px] font-bold uppercase tracking-widest text-gray-500 mb-4" data-id="element-150" data-mp="ym0rl5xonlqy">
        On This Page
      </h2>
      <ul className="space-y-2.5" data-id="element-151" data-mp="tluvndkdrd32">
        {[...sections, {
        id: faqId,
        heading: 'Frequently Asked Questions'
      }].map(section => {
        const isActive = activeId === section.id;
        return <li key={section.id} data-id="element-152" data-mp="fno7ip58grgl">
                <a href={`#${section.id}`} aria-current={isActive ? 'true' : undefined} className={`block text-sm leading-snug transition-colors duration-150 ${isActive ? 'text-navy font-semibold' : 'text-gray-600 hover:text-navy'}`} data-id="element-153" data-mp="foprxk852qaz">
                  {section.heading}
                </a>
              </li>;
      })}
      </ul>
    </nav>;
}